export function formatStorageSize(size: number): string {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let index = 0;

  while (size >= 1024 && index < units.length - 1) {
    size /= 1024;
    index++;
  }

  // 如果是整数就不显示小数，如果有小数就保留两位
  const formattedSize = Number.isInteger(size) ? size.toString() : size.toFixed(2);
  return `${formattedSize}${units[index]}`;
}

export function isUserCreatedWithin24Hours(
  systemTimestamp: number,
  userCreatedTimestamp: number,
): boolean {
  if (!systemTimestamp || !userCreatedTimestamp) {
    return false;
  }
  const diffInMilliseconds = systemTimestamp - userCreatedTimestamp;
  const hoursDifference = diffInMilliseconds / (1000 * 60 * 60);
  return hoursDifference < 24;
}
